import axios from "axios";
import React, { useEffect, useState } from "react";
import { AUTH, AUTHH, BASE_URL, IMAGE_URL } from "../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import { formatDate, formattedDateLong } from "../Date";
import { Modal } from "react-bootstrap";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useNavigate } from "react-router-dom";
import {
    formatCurrencyIndian,
    formatDateTime,
    formatRoundoff2D,
    handleErrorToast,
    ViewRequestRemarks,
    ViewRequestStatus,
    getMonthName,
} from "../CustomFunctions";
import { DownloadInvoiceBilling } from "../SiteManagement/BulkModals"
import usePermission from "../../config/permissions";
import {
    CheckGreen,
    WarnYellow,
    Eye,
    Filter,
    Office,
    CrossRed,
    Attachment,
    Employee,
} from "../AllSvg";
import { Projects } from "../FilterDropdown";
// import { DownloadInvoiceBill } from "../SiteManagement/BulkModals";
import {
    ApproveRequestInvoiceBillingChecker,
    RejectRequestInvoiceBillingChecker,

    ApproveRequestInvoiceBillingAuthority,
    RejectRequestInvoiceBillingAuthority,

    ApproveRequestInvoiceBillingAccStage1,
    RejectRequestInvoiceBillingAccStage1,
    ApprovedInvoiceBillingAdminC1,
    ApprovedInvoiceBillingAdminC2,
    ApprovedInvoiceBillingAdminC3,
    RejectInvoiceBillingAdminC1,
    RejectInvoiceBillingAdminC2,
    RejectInvoiceBillingAdminC3,

    ApproveRequestInvoiceBillingAccStage2,
    RejectRequestInvoiceBillingAccStage2,
} from "./InvoiceBillingActionButton";

const RequestInvoiceBillingChecker = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapicheckerfilter/${selectedStatus}/${fromdate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <Dashboardnavbar
                name={"Invoice Billing Checker"}
                url="Invoice Billing Checker"
            />
            <div className="content-tabs">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(e.target.value === "" ? "null" : e.target.value)
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id"
                                    toggleProject={selectedProject}
                                    setToggleProject={setProject}
                                    subcompany={selectedDivision}
                                />
                            </div>
                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">S.No.</th>
                                    <th className="table-heading-text text-center">Invoice Number</th>
                                    <th className="table-heading-text text-center">Month</th>
                                    <th className="table-heading-text text-center">Year</th>
                                    <th className="table-heading-text text-center">View Invoice</th>
                                    <th className="table-heading-text text-end">Payment Receipt</th>

                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-center">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner"></div>
                            ) : (
                                <tbody>
                                    {officeBillings.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body text-center">{i.invoice_number}</td>
                                                <td className="table-body text-center">{i.month}</td>
                                                <td className="table-body text-center">{i.year}</td>

                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                                </td>
                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                </td>
                                                <ViewRequestStatus i={i} approval_stages_data={i?.approval_stages_data

                                                } />

                                                <ViewRequestRemarks i={i} approval_stages_data={i?.approval_stages_data

                                                } />
                                                <td className="table-body">
                                                    <div className="flex-row ">
                                                        <>
                                                            {i.checker_approval_status === "approved" ? (
                                                                <></>
                                                            ) : (
                                                                <ApproveRequestInvoiceBillingChecker
                                                                    i={i}
                                                                    getofficebillingdata={getofficebillingdata}
                                                                    documentlist={i?.Invoice_details?.documents}
                                                                />

                                                            )}
                                                        </>
                                                        <>
                                                            {
                                                                i.checker_approval_status === "rejected" ? (
                                                                    <></>
                                                                ) : (
                                                                    <RejectRequestInvoiceBillingChecker
                                                                        i={i}
                                                                        getofficebillingdata={getofficebillingdata}
                                                                        documentlist={i?.Invoice_details?.documents}
                                                                    />

                                                                )
                                                            }
                                                        </>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const RequestInvoiceBillingAuthority = (showdashboard) => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiauthorityfilter/${sessionStorage.getItem("sitemanagement_emp_id")}/${selectedStatus}/${fromdate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            {
                showdashboard?.showdashboard === "false" ? (
                    <></>
                ) : (
                    <Dashboardnavbar name={"Admin Office Billing"} url="Admin Office Billing" />
                )
            }
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className={showdashboard.showdashboard === "false" ? "" : "content-tabs"}>
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(
                                                e.target.value === "" ? "null" : e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id"
                                    toggleProject={selectedProject}
                                    setToggleProject={setProject}
                                    subcompany={selectedDivision}
                                />
                            </div>
                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">S.No.</th>
                                    <th className="table-heading-text text-center">Invoice Number</th>
                                    <th className="table-heading-text text-center">Month</th>
                                    <th className="table-heading-text text-center">Year</th>
                                    <th className="table-heading-text text-center">View Invoice</th>
                                    <th className="table-heading-text text-end">Payment Receipt</th>

                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner"></div>
                            ) : (
                                <tbody>
                                    {officeBillings.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">
                                                    {i?.Invoice_details?.project_short_name}
                                                </td>
                                                <td className="table-body">{i.Invoice_name}</td>
                                                <td className="table-body">{i.Invoice_num}</td>
                                                <td className="table-body">{i.date ? formatDate(i.date) : "-"}</td>
                                                <td className="table-body">{i.days}</td>
                                                <td className="table-body">{getMonthName(i.month)}</td>
                                                <td className="table-body">{i.year}</td>
                                                <td className="table-body text-center">{i.fixed_km}</td>
                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                                </td>
                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                </td>
                                                <ViewRequestStatus i={i} approval_stages_data={i?.approval_stages_data

                                                } />

                                                <ViewRequestRemarks i={i} approval_stages_data={i?.approval_stages_data

                                                } />
                                                <td className="table-body">
                                                    <div className="flex-row ">
                                                        <>
                                                            {i.authority_approval_status === "approved" ? (
                                                                <></>
                                                            ) : (
                                                                <ApproveRequestInvoiceBillingAuthority
                                                                    i={i}
                                                                    getofficebillingdata={getofficebillingdata}
                                                                    documentlist={i?.Invoice_details?.documents}
                                                                />
                                                            )}
                                                        </>
                                                        <>
                                                            {
                                                                i.authority_approval_status === "rejected" ? (
                                                                    <></>
                                                                ) : (
                                                                    <RejectRequestInvoiceBillingAuthority
                                                                        i={i}
                                                                        getofficebillingdata={getofficebillingdata}
                                                                        documentlist={i?.Invoice_details?.documents}
                                                                    />
                                                                )
                                                            }
                                                        </>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const RequestInvoiceBillingAdmin = (showdashboard) => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    const [selectedStatustwo, setSelectedStatustwo] = useState("");
    const [selectedStatus3, setSelectedStatus3] = useState("");
    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiadminsC1filter/${selectedStatus}/${fromdate}/${todate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getofficebillingdata2 = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiadminsC2filter/${selectedStatus}/${fromdate}/${todate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getofficebillingdata3 = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiadminsC3filter/${selectedStatus}/${fromdate}/${todate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };
    useEffect(() => {
        if (selectedStatustwo !== "") {
            getofficebillingdata2()
            getSubCompany();
        }
    }, [selectedStatustwo])

    useEffect(() => {
        if (selectedStatus3 != "") {
            console.log("useefect running", selectedStatus3)
            getofficebillingdata3()
            getSubCompany();
        }
    }, [selectedStatus3])
    useEffect(() => {
        getEmpcode();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            {
                showdashboard?.showdashboard === "false" ? (
                    <></>
                ) : (
                    <Dashboardnavbar name={"Admin Office Billing"} url="Admin Office Billing" />
                )
            }
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className={showdashboard.showdashboard === "false" ? "" : "content-tabs"}>
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(
                                                e.target.value === "" ? "null" : e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div" title="admin2">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatustwo}
                                    onChange={(e) => setSelectedStatustwo(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div" title="admin3">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus3}
                                    onChange={(e) => setSelectedStatus3(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id"
                                    toggleProject={selectedProject}
                                    setToggleProject={setProject}
                                    subcompany={selectedDivision}
                                />
                            </div>
                        </div>
                        <div className="btn-cont"><DownloadInvoiceBilling projectList={officeBillings} />
                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text">S.No.</th>
                                    <th className="table-heading-text text-center">Invoice Number</th>
                                    <th className="table-heading-text text-center">Month</th>
                                    <th className="table-heading-text text-center">Year</th>
                                    <th className="table-heading-text text-center">View Invoice</th>
                                    <th className="table-heading-text text-end">Payment Receipt</th>

                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-center">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>
                            ) : (
                                <tbody>
                                    {officeBillings.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>
                                                <td className="table-body text-center">{i.invoice_number}</td>
                                                <td className="table-body text-center">{i.month}</td>
                                                <td className="table-body text-center">{i.year}</td>

                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                                </td>
                                                <td className="table-body">
                                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                </td>
                                                <ViewRequestStatus i={i} approval_stages_data={i?.approval_stages_data

                                                } />

                                                <ViewRequestRemarks i={i} approval_stages_data={i?.approval_stages_data

                                                } />
                                                <td className="table-body">

                                                    {(i?.approval_stages_data?.admin1 || i?.approval_stages_data?.admin2 || i?.approval_stages_data?.admin3) && (
                                                        <div className="flex-row" style={{ justifyContent: "center" }}>

                                                            {(() => {
                                                                const sessionEmpCode = sessionStorage.getItem("sitemanagement_emp_code");

                                                                // Check if this employee has already approved a request
                                                                const hasUserAlreadyApproved =
                                                                    sessionEmpCode === i.admin_update_by_c1 ||
                                                                    sessionEmpCode === i.admin_update_by_c2 ||
                                                                    sessionEmpCode === i.admin_update_by_c3;

                                                                // Check if employee is assigned in approval_stages_data
                                                                const isUserAssigned =
                                                                    sessionEmpCode === i?.approval_stages_data?.admin1_emp ||
                                                                    sessionEmpCode === i?.approval_stages_data?.admin2_emp ||
                                                                    sessionEmpCode === i?.approval_stages_data?.admin3_emp;

                                                                // Function to render approval buttons for a specific admin
                                                                const renderApprovalButtons = (adminNum, empCode, updateBy, approvalStatus) => {
                                                                    if (hasUserAlreadyApproved) return null; // Hide if employee has already approved or is assigned

                                                                    if (empCode === null || sessionEmpCode === empCode) {
                                                                        if (!updateBy && approvalStatus !== "approved" && approvalStatus !== "rejected") {
                                                                            return (
                                                                                <div className="flex-row">
                                                                                    <ApprovedInvoiceBillingAdminC1
                                                                                        i={i}
                                                                                        getofficebillingdata={getofficebillingdata}
                                                                                        documentlist={i?.documents}
                                                                                    />
                                                                                    <RejectInvoiceBillingAdminC1
                                                                                        i={i}
                                                                                        getofficebillingdata={getofficebillingdata}
                                                                                        documentlist={i?.documents}
                                                                                    />
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                    return null;
                                                                };

                                                                // Render approval options for only one admin at a time, ensuring same user can't act twice
                                                                return (
                                                                    renderApprovalButtons(1, i?.approval_stages_data?.admin1_emp, i.admin_update_by_c1, i.admin_approval_status_c1) ||
                                                                    renderApprovalButtons(2, i?.approval_stages_data?.admin2_emp, i.admin_update_by_c2, i.admin_approval_status_c2) ||
                                                                    renderApprovalButtons(3, i?.approval_stages_data?.admin3_emp, i.admin_update_by_c3, i.admin_approval_status_c3)
                                                                );
                                                            })()}
                                                        </div>
                                                    )}



                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const InvoiceBillingAccManagement = () => {
    const [toggleState, setToggleState] = useState(1);

    const gettitles = () => {
        switch (toggleState) {
            case 1:
                return "Invoice Billing AccStage1";
            case 2:
                return "Invoice Billing AccStage2";

            default:
                return "Invoice Billing AccStage1";
        }
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Dashboardnavbar name={gettitles()} url="Admin Requests Management" />
            <div className="content-tabs">
                {/* <TeamRequestManagment secondtoggle={secondtoggle} /> */}
                <>
                    <div>
                        <div className="bloc-tabs-with-white-bg">
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Invoice Billing AccStage1
                            </button>

                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(2)}
                            >
                                Invoice Billing AccStage2
                            </button>
                        </div>

                        <div className="content-tabs-without-margin">
                            {toggleState === 1 ? <RequestInvoiceBillingAccStage1 /> : null}
                            {toggleState === 2 ? <RequestInvoiceBillingAccStage2 /> : null}
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

const RequestInvoiceBillingAccStage1 = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiaccountstatusafilter/${selectedStatus}/${fromdate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading">
                    {" "}
                </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) =>
                                        setFromDate(e.target.value === "" ? "null" : e.target.value)
                                    }
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Office />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                type="text"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                            >
                                <option value="null">All Sub Companies</option>
                                {SubCompany.sort((a, b) => a.title - b.title).map(
                                    (i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    )
                                )}
                                ;
                            </select>

                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Projects usedFor="filter" value="id"
                                toggleProject={selectedProject}
                                setToggleProject={setProject}
                                subcompany={selectedDivision}
                            />
                        </div>
                    </div>
                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">S.No.</th>
                                <th className="table-heading-text text-center">Invoice Number</th>
                                <th className="table-heading-text text-center">Month</th>
                                <th className="table-heading-text text-center">Year</th>
                                <th className="table-heading-text text-center">View Invoice</th>
                                <th className="table-heading-text text-end">Payment Receipt</th>

                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {officeBillings.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="custom-table-head-td">
                                            <td className="table-body text-lefttt">{index + 1}</td>
                                            <td className="table-body">
                                                {i?.Invoice_details?.project_short_name}
                                            </td>
                                            <td className="table-body">{i.Invoice_name}</td>
                                            <td className="table-body">{i.Invoice_num}</td>
                                            <td className="table-body">{i.date ? formatDate(i.date) : "-"}</td>
                                            <td className="table-body">{i.days}</td>
                                            <td className="table-body">{getMonthName(i.month)}</td>
                                            <td className="table-body">{i.year}</td>
                                            <td className="table-body text-center">{i.fixed_km}</td>
                                            <td className="table-body">
                                                {formatCurrencyIndian(i.fixed_bill_amt)}
                                            </td>
                                            <td className="table-body">
                                                {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                            </td>
                                            <ViewRequestStatus i={i} approval_stages_data={i?.approval_stages_data

                                            } />

                                            <ViewRequestRemarks i={i} approval_stages_data={i?.approval_stages_data

                                            } />
                                            <td className="table-body">
                                                <div className="flex-row ">
                                                    <>
                                                        {i.account_status_a === "approved" ? (
                                                            <></>
                                                        ) : (
                                                            <ApproveRequestInvoiceBillingAccStage1
                                                                i={i}
                                                                getofficebillingdata={getofficebillingdata}
                                                                documentlist={i?.Invoice_details?.documents}
                                                            />
                                                        )}
                                                    </>
                                                    <>

                                                        {i.account_status_a === "rejected" ? (
                                                            <></>
                                                        ) : (
                                                            <RejectRequestInvoiceBillingAccStage1
                                                                i={i}
                                                                getofficebillingdata={getofficebillingdata}
                                                                documentlist={i?.Invoice_details?.documents}
                                                            />
                                                        )}

                                                    </>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const RequestInvoiceBillingAccStage2 = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/consultantinvoiceapiaccountstatusbfilter/${selectedStatus}/${fromdate}/${selectedProject}/`
            );
            setOfficeBillings(res.data.bills)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading">
                    {" "}
                </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) =>
                                        setFromDate(e.target.value === "" ? "null" : e.target.value)
                                    }
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Office />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                type="text"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                            >
                                <option value="null">All Sub Companies</option>
                                {SubCompany.sort((a, b) => a.title - b.title).map(
                                    (i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    )
                                )}
                                ;
                            </select>

                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Projects usedFor="filter" value="id"
                                toggleProject={selectedProject}
                                setToggleProject={setProject}
                                subcompany={selectedDivision}
                            />
                        </div>
                    </div>
                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">S.No.</th>
                                <th className="table-heading-text text-center">Invoice Number</th>
                                <th className="table-heading-text text-center">Month</th>
                                <th className="table-heading-text text-center">Year</th>
                                <th className="table-heading-text text-center">View Invoice</th>
                                <th className="table-heading-text text-end">Payment Receipt</th>

                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {officeBillings.map((i, index) => (
                                    <React.Fragment key={index}>
                                        <tr className="custom-table-head-td">
                                            <td className="table-body text-lefttt">{index + 1}</td>
                                            <td className="table-body">
                                                {i?.Invoice_details?.project_short_name}
                                            </td>
                                            <td className="table-body">{i.Invoice_name}</td>
                                            <td className="table-body">{i.Invoice_num}</td>
                                            <td className="table-body">{i.days}</td>
                                            <td className="table-body">{getMonthName(i.month)}</td>
                                            <td className="table-body">{i.year}</td>
                                            <td className="table-body text-center">{i.fixed_km}</td>
                                            <td className="table-body">
                                                {formatCurrencyIndian(i.fixed_bill_amt)}
                                            </td>
                                            <td className="table-body">
                                                {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                            </td>
                                            <ViewRequestStatus i={i} approval_stages_data={i?.approval_stages_data

                                            } />

                                            <ViewRequestRemarks i={i} approval_stages_data={i?.approval_stages_data

                                            } />
                                            <td className="table-body">
                                                <div className="flex-row ">
                                                    <>
                                                        {i.account_status_b === "approved" ? (
                                                            <></>
                                                        ) : (
                                                            <ApproveRequestInvoiceBillingAccStage2
                                                                i={i}
                                                                getofficebillingdata={getofficebillingdata}
                                                                documentlist={i?.Invoice_details?.documents}
                                                            />
                                                        )}
                                                    </>
                                                    {/* <>

                                                        {i.account_status_b === "rejected" ? (
                                                            <></>
                                                        ) : (
                                                            <RejectRequestInvoiceBillingAccStage2
                                                                i={i}
                                                                getofficebillingdata={getofficebillingdata}
                                                                documentlist={i.Invoice_details.documents}
                                                            />
                                                        )}

                                                    </> */}
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        )}
                    </table>

                </div>
            </div>
        </>
    );
};

export {
    RequestInvoiceBillingChecker,
    RequestInvoiceBillingAuthority,
    RequestInvoiceBillingAdmin,
    InvoiceBillingAccManagement,
    RequestInvoiceBillingAccStage1,
    RequestInvoiceBillingAccStage2,
};
